import { Row } from 'antd';
import { Text } from 'components/ui/base/typography';
import SelectTag from 'components/ui/composed/selectTag/SelectTag';
import { ListPayload } from 'core/http/response';
import useProductTemplateTags from 'hooks/useProductTemplateTags';
import { FC, useEffect, useState } from 'react';
import { DeclarationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { colors } from 'theme';
import ProductTemplatesTable, { Product } from '../components/ProductTemplatesTable';

interface Props {
    products: Product[];
    selectedTags: string[];
    country?: DeclarationCountry;
    internalType?: DeclarationInternalType;
    messageType?: MessageTypes;
    onTagsSelected: (tags: string[]) => void;
}

const ProductBulkUploadModal: FC<Props> = ({
    products,
    selectedTags,
    onTagsSelected,
    country,
    internalType,
    messageType,
}) => {
    const list: ListPayload<Product> = {
        list: products,
        pageNumber: 0,
        pageSize: 5,
        total: products?.length ?? 0,
    };
    const tagsList = useProductTemplateTags({
        country: country || DeclarationCountry.IRELAND,
        internalType: internalType || DeclarationInternalType.IMPORT,
        messageType: messageType || ('H1' as MessageTypes),
    });
    const [listOfTags, setListOfTags] = useState(tagsList);

    useEffect(() => {
        setListOfTags(tagsList);
    }, [tagsList]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
            }}
        >
            <span
                style={{
                    fontSize: '14px',
                    color: colors.grey9,
                }}
            >
                Check the products from your CSV file and select the ones you would like to import
            </span>
            <div>
                <Row>
                    <SelectTag
                        usedTags={selectedTags}
                        suggestedTags={listOfTags}
                        onSuggestedTagsChange={(value: string[]) => setListOfTags(value)}
                        onUsedTagsChange={(value: string[]) => onTagsSelected(value)}
                    />
                </Row>
            </div>
            <ProductTemplatesTable source={list} newUi />
        </div>
    );
};
export default ProductBulkUploadModal;
